import axios from 'axios';

import { publicAxiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const listCustomerMetaData = () =>
  axios.get(`${getV1RootUrl()}/meta-data-config/customer`, publicAxiosHeader());
